<template lang="pug">
  .price-wrapper(:class="wrapper_class" v-if="show_price")
    .pre-text( v-if="pre_text") {{ pre_text }}

    .price(:class="price_class" v-if="price > 0")
      .price-value {{ price }}
      small {{ local_currency }}


    .price.price-discount(v-if="have_discount")
      .price-value {{ discounted_price }}
      small {{ local_currency }}
</template>

<script>
export default {
  name: "CombinationPrice",
  props: {
    price: Number,
    discount: Number,
    discount_type: String,
    direction: String,
    align: String,
    hide_currency: Boolean,
    currency: String,
    pre_text: String,
    positive_only: {type: Boolean, default: false},
    size: String,
  },
  data() {
    return {
      full_price: this.price,
    }
  },
  computed: {
    show_price(){
      return !this.positive_only || this.discounted_price > 0;
    },
    local_currency(){
      return (this.currency === undefined) ? 'p.' : this.currency
    },
    have_discount(){
      return ['percent', 'fixed_value'].includes(this.discount_type) && (this.discount > 0 || this.price < 0);
    },
    discounted_price() {
      let price;
      if (this.discount_type === 'percent') {
        price = this.discounted_by_percent;
      }
      if (this.discount_type === 'fixed_value') {
        price = this.discounted_by_value;
      }
      if (this.discount_type === 'no_discount') {
        price = this.price;
      }
      return Math.floor(price);
    },
    discounted_by_value() {
      return this.price - this.discount;
    },
    discounted_by_percent() {
      return this.price * (1 - this.discount/100);
    },
    wrapper_class(){
      return (
          `price-wrapper-${this.direction} ` +
          `price-wrapper--size-${this.size} ` +
          ` ${this.align === 'center' ? 'price-wrapper--align-center' : ''} `
      )
    },
    price_class(){
      return this.have_discount ? 'price-old' : 'price-full'
    }
  },
}
</script>

<style scoped>

</style>